////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, isUndefined, map, findIndex, filter } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const userPreferences = {
	[ActionsTypes.GET_USER_PREFERENCES]: (state) =>
		update(state, {
			userPreferences: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_USER_PREFERENCES_SUCCESS]: (state, payload) => {
		return update(state, {
			userPreferences: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_USER_PREFERENCES_FAILURE]: (state, payload) =>
		update(state, {
			userPreferences: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_USER_PREFERENCE]: (state) =>
		update(state, {
			userPreferences: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SET_USER_PREFERENCE_SUCCESS]: (state, payload) => {
		// Replace prev value by new one
		let actualPreferencesList = cloneDeep(state.userPreferences.items)
		let currentUser = cloneDeep(state.user)

		switch (payload.typeURL) {
			case 'shortcut':
				// Update store
				let actualCategoriesList = map(state.userPreferences.items.userShorcutsCategories)

				actualCategoriesList = map(actualCategoriesList, (o) => {
					const ind = findIndex(o.userShorcuts, (b) => b.id === payload.data.id)
					if (ind > -1) o.userShorcuts[ind] = payload.data

					return o
				})

				actualPreferencesList.userShorcutsCategories = actualCategoriesList

				// And also update current user
				let activeShortcuts = []
				map(actualCategoriesList, (elem) => {
					const ar = filter(elem.userShorcuts, { isSelected: true })
					activeShortcuts = [...activeShortcuts, ...ar]
				})
				currentUser.identity.shorcuts = activeShortcuts
				break
			case 'price-ttc':
				// Update store
				if (!isUndefined(payload.data.isPricesTTC)) actualPreferencesList.isPricesTTC = payload.data.isPricesTTC

				// And also update current user
				currentUser.identity.isPricesTTC = payload.data.isPricesTTC

				break
			case 'notification':
				let actualNotificationsList = map(state.userPreferences.items.userNotifications)

				const ind = findIndex(actualNotificationsList, (b) => b.id === payload.data.id)
				if (ind > -1) {
					actualNotificationsList[ind].isSelected = payload.data.isSelected
				}

				actualPreferencesList.userNotifications = actualNotificationsList
				break
			default:
				break
		}

		return update(state, {
			userPreferences: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: actualPreferencesList,
				},
			},
			user: {
				$set: currentUser,
			},
		})
	},
	[ActionsTypes.SET_USER_PREFERENCE_FAILURE]: (state, payload) => {
		return update(state, {
			userPreferences: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_ACTIVED_PREFERENCE]: (state, payload) => {
		return update(state, {
			userPreferences: {
				isActived: {
					$set: payload,
				},
			},
		})
	},
}

export default userPreferences
